/**
 * Инициалы вместо фотографии.
 *
 * ЗАЧЕМ ОН ЕСТЬ. Портреты сотрудников из репозитория убраны, и каждая карточка
 * контакта осталась с веткой-заглушкой. Раньше в ней стоял один и тот же
 * силуэт `UserCircle`: ряд из восьми одинаковых иконок читается как «данные не
 * загрузились», а не как список разных людей. Инициалы различают карточки и
 * при этом ничего о человеке не сообщают.
 *
 * ЦВЕТ СЧИТАЕТСЯ ОТ ИМЕНИ, А НЕ ВЫБИРАЕТСЯ СЛУЧАЙНО. Случайный менялся бы на
 * каждый рендер, и одна и та же карточка мигала бы разными цветами при
 * переключении вкладки. Хеш имени даёт устойчивый цвет: человек запоминает
 * карточку по пятну, как запоминал бы по лицу.
 */

const PALETTE = [
  '#0e9f90',
  '#7c3aed',
  '#0f766e',
  '#b45309',
  '#be123c',
  '#0a6a60',
  '#16a34a',
  '#a21caf',
]

/**
 * Инициалы: первая буква фамилии и первая буква имени.
 *
 * Отчество не берём — три буквы в кружке диаметром 40 px нечитаемы. Одиночное
 * слово («Нурлыбай») отдаёт одну букву, а не половину слова.
 */
export function initialsOf(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (parts.length === 0) return '—'
  const letters = parts.slice(0, 2).map((part) => part[0]!.toUpperCase())
  return letters.join('')
}

/** Устойчивый цвет по имени: одна и та же строка всегда даёт один цвет. */
export function avatarColorOf(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) % 0xffffffff
  }
  return PALETTE[Math.abs(hash) % PALETTE.length]!
}

type InitialsAvatarProps = {
  name: string
  /** Размер шрифта в пикселях. Сам кружок рисует контейнер-заглушка. */
  fontSize?: number
  className?: string
}

export function InitialsAvatar({ name, fontSize = 18, className = '' }: InitialsAvatarProps) {
  return (
    <span
      aria-hidden
      className={`initials-avatar ${className}`}
      style={{ fontSize, lineHeight: 1, fontWeight: 700, letterSpacing: '0.02em' }}
    >
      {initialsOf(name)}
    </span>
  )
}
